/* eslint-disable quotes */
const APPLICATION_LIST = [
  {
    title: 'DACUM 2.0',
    description:
      'Innovative software utilized to craft and refine curricula across various departments at Binus University, ensuring cutting-edge and cohesive educational programs.',
    url: '/app/dacum/overview'
  },
  {
    title: 'LCMS',
    description: `A state-of-the-art content management system serving as the central hub for BCL&D's extensive knowledge repository, seamlessly distributing educational materials to interconnected platforms.`,
    url: '/app/lcms/overview'
  },
  {
    title: 'Yearly Calendar',
    description: `Advanced planning tools designed to map out the journey of each program and modular course, providing a clear roadmap for student progression and achievement.`,
    url: '/app/yearly-calendar/schedule-plan'
  },
  {
    title: 'LIA',
    description: `Sophisticated analytics platform employed to measure and evaluate the effectiveness of training programs, offering data-driven insights to continually enhance the learning experience.`,
    url: '/app/lia/overview'
  }
];

export default APPLICATION_LIST;
